import { render, staticRenderFns } from "./ProformaList.vue?vue&type=template&id=bcdac7a8&scoped=true"
import script from "./ProformaList.vue?vue&type=script&lang=js"
export * from "./ProformaList.vue?vue&type=script&lang=js"
import style0 from "./ProformaList.vue?vue&type=style&index=0&id=bcdac7a8&prod&lang=scss"
import style1 from "./ProformaList.vue?vue&type=style&index=1&id=bcdac7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdac7a8",
  null
  
)

export default component.exports